$(document).ready(function () {
  const debug = true;
  const log = (() => {
    const colors = { info: "#3498db", success: "#2ecc71", error: "#e74c3c" };
    const logFn = (type, ...args) => {
      if (debug) {
        console.log(
          `%cNP-LPZenpatchPet`,
          `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
          ...args
        );
      }
    };
    return {
      info: (...args) => logFn("info", ...args),
      success: (...args) => logFn("success", ...args),
      error: (...args) => logFn("error", ...args),
    };
  })();

  // ── Image toggling on variant group change (dog/cat) ──────
  const slideElDesk = document.querySelector('#purchaseSlide.lp-tr--desktop .slide-1 .card-box img');
  const slideElMob = document.querySelector('#purchaseSlide.lp-tr--mobile .slide-1 .card-box img');
  const slideElDogDeskSrc = slideElDesk ? slideElDesk.src : '';
  const slideElDogMobSrc = slideElMob ? slideElMob.src : '';

  document.querySelector('.lpv2--main-form')?.addEventListener('lpfp:variantGroupChanged', function (e) {
    const group = e.detail.group;
    log.info('Variant group changed:', group);

    // Toggle product images in packs (supports both old zp-pet-- and new lpfp- classes)
    document.querySelectorAll('.lpfp-pack__image-dog, .zp-pet--package__image-dog').forEach(function (img) {
      img.classList.toggle('active', group === 'dog');
    });
    document.querySelectorAll('.lpfp-pack__image-cat, .zp-pet--package__image-cat').forEach(function (img) {
      img.classList.toggle('active', group === 'cat');
    });
    document.querySelectorAll('.lpfp-bundle__image-dog, .zp-pet--bundle__image-dog').forEach(function (img) {
      img.classList.toggle('active', group === 'dog');
    });
    document.querySelectorAll('.lpfp-bundle__image-cat, .zp-pet--bundle__image-cat').forEach(function (img) {
      img.classList.toggle('active', group === 'cat');
    });

    // Toggle slide images
    if (group === 'dog') {
      if (slideElDesk && slideElDogDeskSrc) slideElDesk.src = slideElDogDeskSrc;
      if (slideElMob && slideElDogMobSrc) slideElMob.src = slideElDogMobSrc;
    } else {
      var catBtn = document.querySelector('.lpfp-variant-group-btn[data-variant-group="cat"]');
      var catDsk = catBtn && catBtn.getAttribute('data-src-dsk');
      var catMob = catBtn && catBtn.getAttribute('data-src-mb');
      if (catDsk && slideElDesk) slideElDesk.src = catDsk;
      if (catMob && slideElMob) slideElMob.src = catMob;
    }
  });

  // ── Scroll behavior ──────────────────────────────────────
  $(".lp-tr--learn-more-btn").click(function () {
    $(".lp-tr--scroll-to-learn").fadeIn("slow");
    var sectionHeight = $(".lp-tr--why-kids-love-np-section").outerHeight();
    var sectionOffsetTop = $(".lp-tr--why-kids-love-np-section").offset().top;
    $(window).scroll(function () {
      if ($(window).scrollTop() >= sectionOffsetTop + sectionHeight) {
        $(".lp-tr--scroll-to-learn").fadeOut("fast");
      }
    });
  });

  // ── Tooltips ─────────────────────────────────────────────
  $(".bundle-save-tooltip-box").on("click", function () {
    $(".bundle-save-tooltip-box").tooltip("show");
    setTimeout(function () { $(".bundle-save-tooltip-box").tooltip("update"); }, 50);
  });
  $(".bundle-save-tooltip-box").on("show.bs.tooltip", function () {
    $(this).tooltip("update");
    $("#blur").fadeIn();
  });
  $(".bundle-save-tooltip-box").on("hide.bs.tooltip", function () {
    $("#blur").fadeOut();
  });
  $("#blur").on("click", function () {
    $(".bundle-save-tooltip-box").tooltip("hide");
  });
  $('[data-toggle="tooltip"]').tooltip({
    container: ".form-group",
    boundary: ".form-group",
    animated: true,
    placement: "top",
    trigger: "manual",
    delay: { show: 100, hide: 100 },
  });

  log.success("Page-specific JS initialized");
});
